import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { goToCheckout } from '../lib/checkout';
export function UrgencySection() {
  const scrollToPricing = () => {
    goToCheckout('megapack');
  };
  return <section className="bg-carbon text-white py-12 md:py-16 px-4" data-id="element-257">
      <div className="max-w-2xl mx-auto text-center" data-id="element-258">
        <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-259">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-6" data-id="element-260">
          <CountdownTimer variant="large" data-id="element-261" />
        </div>

        <p className="text-sci-orange font-semibold mb-8" data-id="element-262">
          Después sube $10.000 ARS y no vuelve a bajar.
        </p>

        {/* Progress bar */}
        <div className="mb-6" data-id="element-263">
          <div className="text-sm mb-2" data-id="element-264">Cupos al precio de lanzamiento:</div>
          <div className="w-full bg-gray-700 rounded-full h-4 overflow-hidden" data-id="element-265">
            <div className="bg-sci-orange h-full rounded-full" style={{
            width: '68%'
          }} data-id="element-266"></div>
          </div>
        </div>

        <button onClick={scrollToPricing} className="bg-sci-orange hover:bg-orange-600 text-white font-bold text-lg py-4 px-8 rounded-lg transition-colors w-full max-w-md mx-auto block" data-id="element-267">
          → ASEGURAR MI PRECIO AHORA
        </button>
      </div>
    </section>;
}